export default "__VITE_ASSET__kgpSZilw__"